import { useLanguage } from './LanguageContext';

export const useTranslation = () => {
  const { language, setLanguage, t } = useLanguage();
  
  return {
    t,
    language,
    setLanguage,
  };
};
